import {fetchGet, generateEndpoint} from "../../../utils/request";

export const getGuest  = async({ lineId }) => {
  const url = `${generateEndpoint('getGuest')}?lineId=${lineId}`
  return fetchGet(url, null)
}